<template>
    <footer>
	  <h2><a :href="`${data.url}`" target="_blank">{{ data.website }}</a></h2>
	  <div class="legal">{{ data.legal1 }}</div>
	  <div class="legal">{{ data.legal2 }}</div>
    </footer>
</template>

<script>
    import data from '../assets/data'

    export default {
      name: 'Footer',
      data: () => {
        return {
          data
        }
      },            
      props: {
        msg: String
      }
    }
</script>

<style scoped>
</style>
